// Remembers whether the host last set up a quick game or a normal-paced one, so
// the next lobby they open starts on the pace they actually play at instead of
// the server default.
//
// Kept in localStorage (per browser, like the volume and piece preferences)
// rather than on the account: it is a convenience default, not part of a game.
const GAME_PACE_KEY = "mono.isQuickGame"

export const getGamePacePreference = (): boolean | null => {
  try {
    const stored = localStorage.getItem(GAME_PACE_KEY)
    if (stored === null) return null
    return stored === "true"
  } catch {
    // Storage-disabled browsers just get the game's own default.
    return null
  }
}

export const setGamePacePreference = (isQuickGame: boolean) => {
  try {
    localStorage.setItem(GAME_PACE_KEY, String(isQuickGame))
  } catch {}
}
